import React from "react";
import styled from "styled-components";

// components
import Row1 from "./Layout/Row1/index";
import Row2 from "./Layout/Row2/index";

//styles
import breakpoints from "core/breakpoints";
const MobileStyled = styled.div`
    display: block;
    @media (min-width: ${breakpoints.tablet.rem}) {
        display: none;
    }
`;

// component
export const Mobile = () => {
    return (
        <MobileStyled>
            <Row1 />
            <Row2 />
        </MobileStyled>
    );
};

export default Mobile;
